export function bolder() {
  return function (text: string, phrase: string) {
    return phrase ? text.replace(new RegExp("(\\b" + phrase + ")", "gi"), "<span class='bolder'>$1</span>") : text;
  };
}
